import { render, staticRenderFns } from "./ride.vue?vue&type=template&id=54d43b7c&scoped=true&"
import script from "./ride.vue?vue&type=script&lang=js&"
export * from "./ride.vue?vue&type=script&lang=js&"
import style0 from "./ride.vue?vue&type=style&index=0&id=54d43b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d43b7c",
  null
  
)

export default component.exports